import { EXPERIMENT_NAME as AUDIENCE_SERP_LIGHT_EXPERIMENT_NAME } from '../../utils/experiments/audienceSerpLight';

export const EXPERIMENTS = [
  'nps',
  'top3_photo_size',
  'message_button_for_jk_card',
  'king_size_card',
  'offer_title_for_vas',
  'newbuilding-serp-filters',
  'newbuilding-serp-filter-checkbox',
  'newbuilding-serp-from-developer',
  'offers_in_kp',
  'degradation_of_payed_card',
  'slonotop-card',
  'flat_disable_top3',
  'audience_serp_filters_neighbors',
  'ab_newbuilders_promo_form',
  'audience_serp_filters_dropdown_rent',
  'audience_serp_filters_dropdown_suburban',
  AUDIENCE_SERP_LIGHT_EXPERIMENT_NAME,
  'countryside_card_integration',
  'countryside_promotions',
  'history_search',
  'call_button_name_offer',
  'card_visibility_observation',
];
